export var PAGE_LAYOUT;
(function (PAGE_LAYOUT) {
    PAGE_LAYOUT["loading"] = "loading";
    PAGE_LAYOUT["chooseAccountView"] = "chooseAccountView";
})(PAGE_LAYOUT || (PAGE_LAYOUT = {}));
export var ERRORS;
(function (ERRORS) {
    ERRORS["invalidInviteLink"] = "invalidInviteLink";
    ERRORS["useCompanyEmail"] = "useCompanyEmail";
    ERRORS["somethingWentWrong"] = "somethingWentWrong";
    ERRORS["tryADifferentAccount"] = "tryADifferentAccount";
    ERRORS["existingMealBenefits"] = "existingMealBenefits";
})(ERRORS || (ERRORS = {}));
